var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-none",style:({
    color: _vm.color,
    background: _vm.background,
    border: _vm.inverted ? '1px solid #00405B !important' : '',
  }),attrs:{"flat":"","depressed":""},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }